import { FC, lazy } from 'react';
import { useNavigate } from 'react-router';

import { useRoleAccess } from '@/services/roles';
import { ROUTES_TO_ROLES_RELATION_MAP } from '@/services/roles/constants.ts';
import { EAdminRoutes } from '@/services/router/enums';
import { ErrorComponent } from '@/ui/error';

export const NotFoundPage: FC = () => {
    const navigate = useNavigate();
    const hasAccess = useRoleAccess();

    return (
        <ErrorComponent
            errorCode={404}
            onButtonClick={
                hasAccess(ROUTES_TO_ROLES_RELATION_MAP.get(EAdminRoutes.Dashboard))
                    ? () => navigate(EAdminRoutes.Dashboard)
                    : undefined
            }
        />
    );
};

export const NotFoundPageLazy = lazy(async () => {
    const { NotFoundPage } = await import('./page');

    return { default: NotFoundPage };
});
